module.exports = __webpack_public_path__ + "img/suc.b2292cbc.png";